import { splitFamily } from 'domain/shared/employee';
import { FamilyData, FamilyMember } from './types';

export const useFamilyData = (isEditMode: boolean, formData: any, employee: any): FamilyData => {
  const raw = employee?.getValueBySource('extendedInformation.familyMembers') || [];
  const split = splitFamily(raw);

  const children = isEditMode ? (formData?.extendedInformation?.children ?? []) : (split.children ?? []);
  const other = isEditMode ? (formData?.extendedInformation?.other ?? []) : (split.other ?? []);

  return { children, other };
};

export const createNewFamilyMember = (): FamilyMember => ({
  id: crypto.randomUUID(),
  name: { firstName: '', middleName: '', lastName: '', maidenName: null },
  dateOfBirth: '',
  relation: '',
  phoneNumber: null,
  isNew: true,
});

export const addLocalIdToMembers = (members: FamilyMember[] = []): FamilyMember[] =>
  members.map(member => ({
    ...member,
    localId: member.localId ?? crypto.randomUUID(),
  }));
